import App from '../App'

// 首页
const index = r => require.ensure([], () => r(require('@/page/index')), 'index')

// 基因详情页
const geneDetails = r => require.ensure([], () => r(require('@/page/geneDetails')), 'geneDetails')

// 旧版基因详情页
const oldGeneDetails = r => require.ensure([], () => r(require('@/page/oldGeneDetails')), 'oldGeneDetails')

// 检索结果
const searchResult = r => require.ensure([], () => r(require('@/page/searchResult')), 'searchResult')

// 高级检索
const advancedSearch = r => require.ensure(
  [],
  () => r(require('@/page/advancedSearch')),
  'advancedSearch'
)

// 新闻列表
const newsList = r => require.ensure([], () => r(require('@/page/newsList')), 'newsList')

// 新闻详情页
const newsDetails = r => require.ensure([], () => r(require('@/page/newsDetails')), 'newsDetails')

// 公用分析页面
const analysis = r => require.ensure([], () => r(require('@/page/analysis')), 'analysis')

// 样本聚类分析第二步
const sampleCompareSecond = r => require.ensure([], () => r(require('@/page/sampleCompareSecond')), 'sampleCompareSecond')

// 样本聚类分析第三步
const sampleCompareThird = r => require.ensure([], () => r(require('@/page/sampleCompareThird')), 'sampleCompareThird')

// 样本聚类分析第四步
const sampleCompareFourth = r => require.ensure([], () => r(require('@/page/sampleCompareFourth')), 'sampleCompareFourth')

// 样本聚类分析提交
const sampleCompareNext = r => require.ensure([], () => r(require('@/page/sampleCompareNext')), 'sampleCompareNext')

// 样本聚类分析结果
const sampleCompareResult = r => require.ensure([], () => r(require('@/page/sampleCompareResult')), 'sampleCompareResult')

// GEM图表
const GEMCharts = r => require.ensure([], () => r(require('@/page/GEMCharts')), 'GEMCharts')

// Blast
const blast = r => require.ensure([], () => r(require('@/page/blast')), 'blast')

// 统计
const statistics = r => require.ensure([], () => r(require('@/page/statistics')), 'statistics')

// 基因组浏览器
const genomeBrowser = r => require.ensure([], () => r(require('@/page/genomeBrowser')), 'genomeBrowser')

// 疾病
const disease = r => require.ensure([], () => r(require('@/page/disease')), 'disease')

// 帮助
const help = r => require.ensure([], () => r(require('@/page/help')), 'help')

// 测试
const test = r => require.ensure([], () => r(require('@/page/test')), 'test')

export default [
  {
    path: '/',
    component: App, // 顶层路由，对应index.html
    children: [
      {
        path: '/',
        name: 'index',
        component: index
      },
      {
        path: '/advancedSearch',
        name: 'advancedSearch',
        component: advancedSearch
      },
      {
        path: '/searchResult',
        name: 'searchResult',
        component: searchResult
      },
      {
        path: '/sampleCompareSecond',
        name: 'sampleCompareSecond',
        component: sampleCompareSecond
      },
      {
        path: '/sampleCompareThird',
        name: 'sampleCompareThird',
        component: sampleCompareThird
      },
      {
        path: '/sampleCompareFourth',
        name: 'sampleCompareFourth',
        component: sampleCompareFourth
      },
      {
        path: '/sampleCompareNext',
        name: 'sampleCompareNext',
        component: sampleCompareNext
      },
      {
        path: '/sampleCompareResult',
        name: 'sampleCompareResult',
        component: sampleCompareResult
      },
      {
        path: '/GEMCharts',
        name: 'GEMCharts',
        component: GEMCharts
      },
      {
        path: '/blast',
        name: 'blast',
        component: blast
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: statistics
      },
      {
        path: '/newsDetails',
        name: 'newsDetails',
        component: newsDetails
      },
      {
        path: '/newsList',
        name: 'newsList',
        component: newsList
      },
      {
        path: '/disease',
        name: 'disease',
        component: disease
      },
      {
        path: '/help',
        name: 'help',
        component: help
      },
      {
        path: '/test',
        name: 'test',
        component: test
      },
      {
        path: '/geneDetails',
        name: 'geneDetails',
        component: geneDetails
      },
      {
        path: '/oldGeneDetails',
        name: 'oldGeneDetails',
        component: oldGeneDetails
      },
      {
        path: '/genomeBrowser',
        name: 'genomeBrowser',
        component: genomeBrowser
      },
      {
        path: '/analysis',
        name: 'analysis',
        component: analysis
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js